import { AlertDialogModel, ConfirmDialogModel } from '../../models'
import { hideAlert, hideConfirm, updateAlert, updateConfirm } from '../slices/DialogSlice'

const showConfirmDialog = (dialog: ConfirmDialogModel) => {
    return async (dispatch: (arg0: { payload: any; type: string }) => void) => {
        const model: ConfirmDialogModel = {
            Show: true,
            Header: dialog.Header ?? 'Confirm',
            Body: dialog.Body,
            ConfirmButtonText: dialog.ConfirmButtonText ?? 'OK',
            CancelButtonText: dialog.CancelButtonText ?? 'Cancel',
            ConfirmButtonAction: dialog.ConfirmButtonAction,
            CancelButtonAction: dialog.CancelButtonAction,
        }

        dispatch(updateConfirm(model))
    }
}

const hideConfirmDialog = () => {
    return async (dispatch: (arg0: { payload: any; type: string }) => void) => {
        dispatch(hideConfirm())
    }
}

const showAlertDialog = (dialog: AlertDialogModel) => {
    return async (dispatch: (arg0: { payload: any; type: string }) => void) => {
        const model: AlertDialogModel = {
            Show: true,
            Header: dialog.Header ?? 'Alert',
            Body: dialog.Body,
            OkButtonText: dialog.OkButtonText ?? 'OK',
            OkButtonAction: dialog.OkButtonAction,
        }

        dispatch(updateAlert(model))
    }
}

const hideAlertDialog = () => {
    return async (dispatch: (arg0: { payload: any; type: string }) => void) => {
        dispatch(hideAlert())
    }
}

export { showConfirmDialog, hideConfirmDialog, showAlertDialog, hideAlertDialog }
